<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <base-modal-setting size="small" :open="active" v-on:close="$emit('close')">
      <!-- #region tabs com opção de criar novo conjunto de parâmetros e importar parâmetros à partir de uma hash -->
      <ontick-div class="text-ontick-carbon-900 dark:text-gray-300">
        <!-- #region tab -->
        <ontick-div
          class="border-ontick-steel-200 dark:border-ontick-graphite-600 bg-ontick-steel-100 dark:bg-ontick-graphite-500 flex overflow-auto rounded-t-lg border-b"
        >
          <a
            href="javascript:void(0);"
            v-for="(tab, i) in tab_options"
            :key="i"
            @click="active_tab = tab.tag"
            :class="[
              active_tab == tab.tag ? tab_style.active : tab_style.inactive,
              tab_style.all,
            ]"
          >
            <svg
              v-if="tab.tag == 'novo'"
              class="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              ></path>
            </svg>
            <svg
              v-if="tab.tag == 'importar'"
              class="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
              ></path>
            </svg>
            <span class="whitespace-no-wrap ml-2">{{ tab.name }}</span>
          </a>
        </ontick-div>
        <!-- #endregion -->

        <!-- #region conteúdo da tab "novo" -->
        <ontick-div v-if="active_tab == 'novo'" class="p-6">
          <ontick-div class="pb-3">
            <ontick-text class="mb-1">Criar com base em:</ontick-text>
            <modal-select
              @change="param.hash_value = $event.param_code"
            ></modal-select>
            <ontick-text
              v-if="param.errors.hash_value"
              size="small"
              color="red"
              weight="medium"
              >{{ param.errors.hash_value }}</ontick-text
            >
          </ontick-div>
          <ontick-div>
            <ontick-text class="mb-1">Rótulo:</ontick-text>
            <input
              type="text"
              v-model="param.param_name"
              placeholder="Rótulo"
              maxlength="32"
              class="text-ontick-base input_form dark:border-ontick-carbon-500 border-ontick-steel-200 dark:bg-ontick-graphite-500 bg-ontick-steel-200 text-ontick-carbon-900 block w-full appearance-none rounded px-3 py-2 focus:border-red-500 focus:outline-none dark:text-gray-300 sm:text-sm"
              required
            />
            <ontick-text
              v-if="param.errors.param_name"
              size="small"
              color="red"
              weight="medium"
              >{{ param.errors.param_name }}</ontick-text
            >
          </ontick-div>
        </ontick-div>
        <!-- #endregion -->

        <!-- #region conteúdo da tab "novo" -->
        <ontick-div v-show="active_tab == 'importar'" class="p-6">
          <ontick-div class="pb-3">
            <ontick-text class="mb-1">Código do parâmetro:</ontick-text>
            <input
              type="text"
              v-model="param.hash_value"
              @keyup="param.hash_value = keyupHashCode($event)"
              :placeholder="info.param_code"
              class="text-ontick-base input_form dark:border-ontick-carbon-500 border-ontick-steel-200 dark:bg-ontick-graphite-500 bg-ontick-steel-200 text-ontick-carbon-900 block w-full appearance-none rounded px-3 py-2 focus:border-red-500 focus:outline-none dark:text-gray-300 sm:text-sm"
              maxlength="8"
            />
            <ontick-text
              v-if="param.errors.hash_value"
              size="small"
              color="red"
              weight="medium"
              >{{ param.errors.hash_value }}</ontick-text
            >
          </ontick-div>
          <ontick-div>
            <ontick-text class="mb-1">Rótulo:</ontick-text>
            <input
              type="text"
              v-model="param.param_name"
              placeholder="Rótulo"
              maxlength="32"
              class="text-ontick-base input_form dark:border-ontick-carbon-500 border-ontick-steel-200 dark:bg-ontick-graphite-500 bg-ontick-steel-200 text-ontick-carbon-900 block w-full appearance-none rounded px-3 py-2 focus:border-red-500 focus:outline-none dark:text-gray-300 sm:text-sm"
              required
            />
            <ontick-text
              v-if="param.errors.param_name"
              size="small"
              color="red"
              weight="medium"
              >{{ param.errors.param_name }}</ontick-text
            >
          </ontick-div>
        </ontick-div>
        <!-- #endregion -->
      </ontick-div>
      <!-- #endregion -->

      <!-- #region footer -->
      <template slot="footer">
        <ontick-div
          orientation="horizontal"
          class="dark:border-ontick-graphite-500 border-ontick-steel-300 justify-end space-x-2 border-t-2 p-3"
        >
          <button
            @click="$emit('close')"
            class="border-ontick-steel-500 text-ontick-steel-500 flex h-10 items-center justify-center rounded border-2 px-3 text-sm font-semibold shadow backdrop-filter transition-all hover:backdrop-brightness-75 dark:border-gray-300 dark:text-gray-300"
          >
            Cancelar
          </button>

          <button
            @click="createNewOrImport"
            v-if="active_tab == 'novo'"
            class="border-ontick-blue-600 bg-ontick-blue-600 flex h-10 items-center justify-center rounded border-2 px-3 text-sm font-semibold text-white shadow filter transition-all hover:brightness-75"
          >
            Criar
          </button>

          <button
            @click="createNewOrImport"
            v-if="active_tab == 'importar'"
            class="border-ontick-blue-600 bg-ontick-blue-600 flex h-10 items-center justify-center rounded border-2 px-3 text-sm font-semibold text-white shadow filter transition-all hover:brightness-75"
          >
            Importar
          </button>
        </ontick-div>
      </template>
      <!-- #endregion -->
    </base-modal-setting>
  </transition>
</template>

<script>
import PincodeInput from "vue-pincode-input";
import { mapActions, mapState } from "vuex";

export default {
  name: "modal-setting",
  components: {
    PincodeInput,
    BaseModalSetting: () => import("./base-modal-setting.component"),
    ModalSelect: () => import("./modal-select.component"),
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      param: {
        hash_value: "",
        param_name: "",
        errors: {},
      },
      options: [],
      selected_option: {},
      tab_options: [
        { tag: "novo", name: "Novo" },
        { tag: "importar", name: "Importar" },
      ],
      active_tab: "novo",
      tab_style: {
        all: "flex flex-1 items-center justify-center text-center px-3 py-4 border-b-2 transform transition-all ",
        active:
          "border-ontick-blue-500 dark:text-white text-ontick-blue-600 font-semibold",
        inactive:
          "border-ontick-steel-300 dark:border-ontick-graphite-500 text-ontick-steel-500 dark:text-gray-400 font-normal",
      },
      //
      code: "",
      styles: {
        button:
          "bg-ontick-third inline-flex items-center px-6 py-3 rounded font-bold text-ontick-light",
        buttonSpan:
          "w-full text-center text-ontick-small text-ontick-white uppercase font-bold",
      },
    };
  },
  computed: {
    ...mapState({
      info: (state) => state.investment.parameters.info,
    }),
    activeModal() {
      return this.active;
    },
  },
  watch: {
    active_tab(value) {
      // para limpar o hash_value definido pelo select.
      this.param = {
        hash_value: "",
        param_name: "",
        errors: {},
      };
      return value;
    },
  },
  methods: {
    ...mapActions({
      createParam: "investment/createParam",
    }),
    keyupHashCode(event) {
      var strSChar = "áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ";
      var strNoSChars = "aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC";
      var word = event.target.value;
      var newStr = "";
      for (var i = 0; i < word.length; i++) {
        newStr +=
          strSChar.indexOf(word.charAt(i)) != -1
            ? strNoSChars.substr(strSChar.search(word.substr(i, 1)), 1)
            : word.substr(i, 1);
      }
      return newStr
        .replace(/[^a-zA-Z 0-9]/g, "")
        .replace(/\d+/g, "")
        .replace(/\s/g, "")
        .trim()
        .toUpperCase();
    },
    createNewOrImport() {
      //#region validações
      if (this.param.hash_value.trim().length == 0) {
        this.param.errors.hash_value = "Código inválido";
      }
      if (this.param.param_name.trim().length == 0) {
        this.param.errors.param_name = "Campo obrigatório";
      } else {
        delete this.param.errors.param_name;
      }
      // foi encontrado um erro.
      if (Object.keys(this.param.errors).length > 0) {
        this.$forceUpdate();
        return;
      }
      // limpando os erros.
      this.param.errors = {};
      //#endregion

      let body = {
        create_type: this.active_tab == "novo" ? "DUPLICATE" : "HASH_COPY",
        investment_id: Number(this.$route.params.investment_id),
        hash_value: this.param.hash_value,
        param_name: this.param.param_name.trim(),
      };
      this.createParam(body)
        .then((response) => {
          this.$emit("close"); //para fechar o modal
          this.$swal({
            title: response.msg,
            icon: "success",
            icon: "success",
            icon: "success",
            iconHtml: this.$icons.swal_success,
            toast: false,
            position: "center",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        })
        .catch((error) => {
          this.param.errors.hash_value = error.msg;
          this.$forceUpdate();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// PINCODE COMPONENT
div.vue-pincode-input-wrapper {
  // any styles you want for wrapper
  background-color: #202a37 !important;
  display: flex;
  justify-content: center;
}

input.vue-pincode-input {
  // any styles you want for each cell
  background-color: #171e27 !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
  color: white !important;
  font-size: 40px !important;
  font-weight: 600 !important;
  padding: 6px 12px !important;
  max-width: 75px;
  margin: 12px;
  border: 2px solid #171e27;
  transition: all 0.3s ease;
  &:focus {
    border: 2px solid #07a4ff;
  }
}

// ::-webkit-input-placeholder {
//   /* Edge */
//   color: #a0aec036;
// }
// :-ms-input-placeholder {
//   /* Internet Explorer 10-11 */
//   color: #a0aec036;
// }
// ::placeholder {
//   color: #a0aec036;
// }
</style>
